export class Prepost {
  claimNo: string = null;
  inwardType: string = null;
}
